export default "__VITE_ASSET__DlaZB4L$__"